<template>
  <div>
    <b-breadcrumb :items="breadCrumbs" />

    <b-row v-if="shippingOrders && shippingOrders.length">
      <b-col md="6" class="my-1">
        <b-form-group horizontal label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input
              v-model="filter"
              placeholder="Type to Search"
              :autofocus="true"
              @blur="trimExpiryDate"
              @change="trimExpiryDate"
              @input="trimExpiryDate"
            />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <div class="float-right" v-if="shippingOrders.length > 0">
          Total orders awaiting shipping allocation: {{ shippingOrders.length }}
        </div>
        <!-- <b-form-group horizontal label="Per page" class="mb-0">
					<b-form-select :options="pageOptions" v-model="perPage" />
        </b-form-group> -->
      </b-col>
    </b-row>

    <b-row class="mt-3" v-if="shippingOrders && shippingOrders.length">
      <b-col md="12">
        <b-table
          :items="shippingOrders"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          v-if="shippingOrders"
        >
          <template slot="cell(order_id)" slot-scope="row">
            {{ row.item.shopify_order_id }}
            <!-- <span v-if="row.item.payment_code === 'blockchain'">
              <br />
              <img
                style="width: 32px;height: 32px;"
                src="/assets/icons/blockchain.png"
              />
            </span> -->
            <!-- <b-badge
              class="text-center"
              variant="warning"
              v-if="!row.item.complete"
              >Partially Picked</b-badge
            > -->
          </template>

          <template slot="cell(actions)" slot-scope="row">
            <div style="width:150px;">
              <b-button
                size="sm"
                v-if="row.item.status_id === 2"
                variant="warning"
                class="ml-2"
                :to="'/shipping/' + row.item.shopify_order_id"
                >Allocate Shipments</b-button
              >
              <b-button
                size="sm"
                v-if="row.item.status_id === 3"
                variant="success"
                class="ml-2"
                @click="printLabel(row.item.shipping_id)"
                >Print Label</b-button
              >
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row v-if="shippingOrders && shippingOrders.length">
      <b-col md="6" class="my-1">
        <b-pagination
          :total-rows="shippingOrders.length"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </b-col>
    </b-row>

    <b-row v-if="!shippingOrders || shippingOrders.length == 0">
      <b-col md="6" class="my-1 offset-md-3">
        <b-alert show variant="success">No Orders to ship. Yay!</b-alert>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "shopify-shipping",
  components: {},
  data() {
    return {
      shippingOrders: null,
      fields: [
        { key: "shopify_order_id", label: "#", sortable: true },
        { key: "created_at", label: "Date" },
        { key: "actions", label: "" }
      ],
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Shipping", active: true }
      ],
      currentPage: 1,
      perPage: 50,
      pageOptions: [10, 25, 50],
      filter: null
    };
  },
  mounted: function() {
    this.listShippingOrders();
  },
  methods: {
    printLabel(id) {
      let url = this.APIURL + this.BRAND + "/shipping/label/" + id;
      window.open(url, "_blank");
    },
    trimExpiryDate() {
      const filter = this.filter;
      var matches = filter.match(/-[0-9]{6}/);
      if (matches) {
        this.filter = filter.split(matches[0])[0];
      }
    },
    listShippingOrders: function() {
      let loader = this.$loading.show();
      this.$http.get(this.APIURL + this.BRAND + "/shipping").then(
        response => {
          this.shippingOrders = response.data;
          loader.hide();
        },
        error => {
          loader.hide();
          console.log(error);
        }
      );
    },
    rowClass: function(shippingMethod) {
      return "";
      // if (this.BRAND == "IM") {
      //   return shippingMethod.toLowerCase().includes("ups")
      //     ? "bg-danger text-white shipping-red"
      //     : "";
      // } else {
      //   return shippingMethod.toLowerCase().includes("express")
      //     ? "bg-danger text-white shipping-red"
      //     : "";
      // }
    }
  }
};
</script>
